import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';
import { map } from 'lodash';

const rowsPerPage = [{ id: 1, rows: 10 }, { id: 2, rows: 15 }, { id: 3, rows: 20 }];

const PaginationLocal = (props) => {
  const {
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageIndex,
    pageSize
  } = props;
  return (
    <div className="qs-table-pagination">
      <div className="qs-table-rows">
        <select
          type="select"
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value));
          }}
        >
          {map(rowsPerPage, (e) => (
            <option key={e.id} value={e.rows}>
              {e.rows}
            </option>
          ))}
        </select>
      </div>
      <div className="qs-table-page">
        <span>Página {pageIndex + 1} de {pageOptions.length}</span>
      </div>
      <div className="qs-table-buttons">
        <button type='button' onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          <FiChevronsLeft size={20} />
        </button>
        <button type='button' onClick={() => previousPage()} disabled={!canPreviousPage}>
          <FiChevronLeft size={20} />
        </button>
        <button type='button' onClick={() => nextPage()} disabled={!canNextPage}>
          <FiChevronRight size={20} />
        </button>
        <button type='button' onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          <FiChevronsRight size={20} />
        </button>
      </div>
    </div>
  );
}

export default PaginationLocal;